/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ActionButtonsReferrals: React.FC<{
  id: string;
  onEyeClick: (id: string) => void;
  onDeleteClick: (id: string) => void;
}> = ({ id, onEyeClick, onDeleteClick }) => {
  return (
    <Stack direction='row' spacing={1}>
      <IconButton
        color='primary'
        aria-label='visiblity'
        onClick={() => onEyeClick(id)}>
        <VisibilityIcon />
      </IconButton>
      <IconButton
        color='primary'
        aria-label='group'
        onClick={() => onDeleteClick(id)}>
        <DeleteOutlinedIcon style={{ color: 'red' }} />
      </IconButton>
    </Stack>
  );
};

export default ActionButtonsReferrals;
